import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["HeroNavImage"] */ "/vercel/path0/src/components/hero-nav-image.tsx");
